import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=6779b8b3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6779b8b3"]])

export default __exports__